import Link from 'next/link';
import Image from 'next/image';

export function MarketingFooter() {
  return (
    <footer className="bg-[#f5f5f5] border-t border-[#e5e5e5]">
      <div className="max-w-[1200px] mx-auto px-6 py-14">
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Image
              src="/images/logo.png"
              alt="TekSpert Mail"
              width={120}
              height={30}
              className="h-5 w-auto object-contain mb-4"
            />
            <p className="text-[14px] text-[#666] leading-relaxed max-w-[300px]">
              Secure email hosting with native desktop apps, custom domain support, and a full-featured web client.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-[13px] font-semibold text-[#333] mb-3 uppercase tracking-[0.04em]">Product</h4>
            <ul className="space-y-2">
              <li><Link href="/features" className="text-[14px] text-[#666] hover:text-[#0078D4]">Features</Link></li>
              <li><Link href="/security" className="text-[14px] text-[#666] hover:text-[#0078D4]">Security</Link></li>
              <li><Link href="/download" className="text-[14px] text-[#666] hover:text-[#0078D4]">Download</Link></li>
              <li><Link href="/pricing" className="text-[14px] text-[#666] hover:text-[#0078D4]">Pricing</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-[13px] font-semibold text-[#333] mb-3 uppercase tracking-[0.04em]">Support</h4>
            <ul className="space-y-2">
              <li><a href="mailto:support@tekspert.co.uk" className="text-[14px] text-[#666] hover:text-[#0078D4]">Contact Support</a></li>
              <li><a href="mailto:support@tekspert.co.uk" className="text-[14px] text-[#666] hover:text-[#0078D4]">Report a Bug</a></li>
              <li><Link href="/auth/login" className="text-[14px] text-[#666] hover:text-[#0078D4]">Account Login</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-[13px] font-semibold text-[#333] mb-3 uppercase tracking-[0.04em]">Legal</h4>
            <ul className="space-y-2">
              <li><Link href="/privacy" className="text-[14px] text-[#666] hover:text-[#0078D4]">Privacy Policy</Link></li>
              <li><Link href="/terms" className="text-[14px] text-[#666] hover:text-[#0078D4]">Terms of Service</Link></li>
              <li><a href="https://tekspert.co.uk" target="_blank" rel="noopener noreferrer" className="text-[14px] text-[#666] hover:text-[#0078D4]">TekSpert.co.uk</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#ddd] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[13px] text-[#999]">© {new Date().getFullYear()} TekSpert Ltd. All rights reserved.</p>
          <p className="text-[13px] text-[#999]">
            <a href="mailto:support@tekspert.co.uk" className="hover:text-[#0078D4]">support@tekspert.co.uk</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
